import { useApiQuery } from 'hooks/useApiQuery'

interface useGetRewardsByLicensedEstablishmentIdParams {
  licensedEstablishmentId?: number
}

export const useGetRewardsByLicensedEstablishmentId = ({
  licensedEstablishmentId,
}: useGetRewardsByLicensedEstablishmentIdParams) =>
  useApiQuery({
    path: '/le-connect/rewards-programs/licensed-establishments/{id}',
    method: 'get',
    queryKey: [
      '/le-connect/rewards-programs/licensed-establishments/',
      licensedEstablishmentId,
    ],
    queryArgs: {
      id: licensedEstablishmentId,
    },
  })
